import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import { renderProp, cloneElement, type RenderFunction } from 'utilsTS/react';

export interface RenderPropProps<P> {
    children?: React.ReactNode | RenderFunction<P>; // children are defined extra due to the function signature option

    /** Accepts a function that renders the output */
    render?: RenderFunction<P>;
    /** Accepts additional props passed to the rendered output */
    argument?: P extends object ? P : never;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [index: string]: any;
}

export const RenderProp = <P,>({
    render = noop,
    argument,
    children,
    ...rest
}: RenderPropProps<P>): React.ReactElement => {
    const result = renderProp(render, children, argument);

    if (Object.keys(rest).length > 0) {
        return cloneElement(result, rest) as React.ReactElement;
    }

    return result as React.ReactElement;
};

RenderProp.displayName = 'RenderProp';
RenderProp.propTypes = {
    render: PropTypes.func,
    argument: PropTypes.shape({}),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};
